import Child from './Child.vue';

export * from './types';
export default Child;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/index.ts